import PenaltyGridRepositoryImpl from './impl/PenaltyGridRepositoryImpl'

export default {
  getInstance () {
    return new PenaltyGridRepositoryImpl()
  }
}
